import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  partner_access_state: "",
  advertiser_id_provided: false,
  marketplace_credentials_provided: false,
  seller_type: "",
  seller_id: null as string | null,
};

interface WalmartOnboardPayload {
  partner_access_state: string;
  advertiser_id_provided: boolean;
  marketplace_credentials_provided: boolean;
  seller_type: string;
  marketplace_seller_id: string;
}

const walmartSlice = createSlice({
  name: "walmart_onboard",
  initialState,
  reducers: {
    updateWalmartOnboardingStatus: (state, action: PayloadAction<WalmartOnboardPayload>) => {
      state.partner_access_state = action.payload.partner_access_state;
      state.advertiser_id_provided = action.payload.advertiser_id_provided;
      state.marketplace_credentials_provided = action.payload.marketplace_credentials_provided;
      state.seller_type = action.payload.seller_type;
      state.seller_id = action.payload.marketplace_seller_id;
    },
  },
});

export const { updateWalmartOnboardingStatus } = walmartSlice.actions;
export default walmartSlice.reducer;
